import type { MouseEvent } from 'react'
import { useState, useEffect, useRef, useCallback } from 'react'

type UseCopyTextProps = {
  disabled: boolean
  preventDefault?: boolean | undefined
  text: string
}

export const useCopyText = ({ disabled, preventDefault, text }: UseCopyTextProps) => {
  const [copyPopUp, setCopyPopUp] = useState('')
  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null)
  const copyToClipboard = useCallback(
    (event: MouseEvent<HTMLElement>) => {
      if (disabled) {
        return
      }
      if (preventDefault) {
        event.preventDefault()
        event.stopPropagation()
      }
      setCopyPopUp('animate')
      const input = document.createElement('input')
      input.style.position = 'fixed'
      input.style.opacity = '0'
      input.value = text
      document.body.appendChild(input)
      /* Get the text field */
      try {
        /* Select the text field */
        input.focus()
        input.select()

        /* Copy the text inside the text field */
        document.execCommand('copy')
      } catch {
        //
      }
      document.body.removeChild(input)
      timeout.current = setTimeout(() => {
        setCopyPopUp('')
      }, 2000)
    },
    [disabled, preventDefault, text],
  )

  useEffect(() => {
    return () => {
      if (timeout.current) {
        clearTimeout(timeout.current)
      }
    }
  }, [])

  return { copyToClipboard, copyPopUp }
}
